/**
 * 
 * @param {*} name 
 */
export const getFirstAndLastName = name => {
  const trimmedName = name.trim();
  const firstname = trimmedName.split(' ').slice(0, -1).join(' ');
  const lastname = trimmedName.split(' ').slice(-1).join(' ');
  return {
    firstname,
    lastname
  };
};